import type { FC } from 'react';
import { VStack, Box } from '@styled-system/jsx';
import { PaywallPcContent } from './pc-content';
import { PaywallSpContent } from './sp-content';

type Props = {
  isMobile?: boolean;
  onClickBecomeVip: () => void;
  onClickAppLink: () => void;
};

export const Paywall: FC<Props> = ({
  onClickBecomeVip,
  onClickAppLink,
  isMobile,
}) => {
  return (
    <VStack
      background="#FFF"
      padding={{ base: '16px', lg: '32px' }}
      textAlign="center"
      borderRadius="8px 8px 0 0"
      gap="0"
      width="100%"
    >
      <Box maxWidth="360px" margin="0 auto" textAlign="center">
        {isMobile ? (
          <PaywallSpContent onClickAppLink={onClickAppLink} />
        ) : (
          <PaywallPcContent onClickBecomeVip={onClickBecomeVip} />
        )}
      </Box>
    </VStack>
  );
};
